<template>
  <div class="half-column">
    <div class="donation-title-2">Type betaling:</div>
    <div v-for="option in options" :key="option.id" class="cursor-select">
      <RadioButton
        v-model="selectedValue"
        @update="update"
        :value="option.value"
        :id="option.id"
      />
    </div>
  </div>
</template>

<script>
import RadioButton from "@/elements/RadioButton.vue"

export default {
  components: {
    RadioButton,
  },
  props: ["initial_value"],
  created() {
    this.selectedValue = this.initial_value
  },
  data: () => {
    return {
      options: [
        { id: "eenmalig", value: "Eenmalig" },
        { id: "periodiek", value: "Periodiek" },
      ],
      selectedValue: "",
    }
  },
  computed: {
    store: function () {
      return this.$store.state
    },
  },
  methods: {
    update() {
      this.store.payment_info.type_payment = this.selectedValue

      let page_ext = "once"
      if (this.selectedValue != "eenmalig") {
        page_ext = "recurring"
      }

      this.store.page.path = [
        {
          page: 1,
          name: "step1",
        },
        {
          page: 2,
          name: "step2_" + page_ext,
        },
        {
          page: 3,
          name: "step3",
        },
      ]
    },
  },
}
</script>

<style scoped>
.half-column {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>
